export enum AppointmentsFilterParam {
  Search = 'q',
  Status = 'status',
  Date = 'date',
  Client = 'client',
  Pet = 'pet',
  Groomer = 'groomer',
  IncludeUnapproved = 'include_unapproved',
}
